import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { Progress } from '@/components/ui/progress';
import { Loader2 } from 'lucide-react';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  text?: string;
  progress?: number | null;
};
export default function FullPageLoader({ open, text, progress = null }: Props) {
  const { t } = useTranslation();
  const displayText = text ?? t('common.status.loading');
  return (
    <Dialog open={open}>
      <DialogContent
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        className='border-none bg-transparent shadow-none outline-none sm:max-w-[380px] [&>button:last-of-type]:hidden'
      >
        <VisuallyHidden>
          <DialogTitle>Loading</DialogTitle>
        </VisuallyHidden>

        <div className='grid place-items-center gap-4 py-6' role='status' aria-live='polite' aria-busy={open}>
          <Loader2 className='h-10 w-10 animate-spin' aria-hidden='true' />
          <DialogDescription className='text-sm text-foreground/80'>{displayText}</DialogDescription>

          {typeof progress === 'number' && <Progress value={progress} className='w-64' />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
